import { Button, Flex, Heading, Input, Stack } from "@chakra-ui/react";
import React from "react";
import { BsSearch } from "react-icons/bs";

export default function Banner() {
  return (
    <Flex
      bgImage={"url('/images/support/banner.png')"}
      height="560px"
      bgSize={"cover"}
      bgRepeat="no-repeat"
      justifyContent={"center"}
      flexDirection="column"
      color="white"
      gap={5}
      backgroundPosition={{ md: "center" }}
      justify="center"
    >
      <Stack gap={8} ml={{ base: 10, md: 20, xl: 60 }} pr={4}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "20px", md: "28px", xl: "43px" }}
        >
          What do you need help with?
        </Heading>
        <Flex
          alignItems="center"
          borderRadius={10}
          overflow="hidden"
          bg="white"
          pl={4}
          maxW="640px"
          marginTop={"0px"}
        >
          <BsSearch color="#707070" size="24px" />
          <Input
            placeholder='Try "Update my account details"'
            py={{ base: 4, xl: 8 }}
            border={0}
          />
          <Button
            bg="brand.100"
            height="full"
            _hover={{ bg: "brand.100" }}
            color="white"
            px={10}
            m={0}
            borderRadius={0}
          >
            Get Started
          </Button>
        </Flex>
      </Stack>
    </Flex>
  );
}
